#import "../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"
mutation PurchaseOrderUpdate($input: PurchaseOrderUpdateInput!) {
  purchaseOrderUpdate(input: $input) {
    purchaseOrder {
      __typename
      id
      sortSupplierName
      _isDistributionUpdateAllowed
      _purchaseOrderDeliveryId
      supplierId
      supplier {
        id
        _fullName
        _isUpdatable
      }
      _isRevisable
      purchaseOrderTypeId
      purchaseOrderDate
      currencyId
      currency {
        id
        isoCode
        currencySymbol
      }
      _subjectToDiscount
      _subjectToTax
      departmentId
      businessUnitId
      businessUnit {
        _isProductionBusinessUnit
        id
        name
        companyAddress {
          addressAlias
          addressLine1
          addressLine2
          cityName
          postalCode
        }
      }
      reason
      description
      controlTotalAmount
      _isUpdatable
      _isDeletable
      deliveryAddressId
      deliveryAddressLine1
      deliveryAddressLine2
      deliveryCityName
      deliveryCountryId
      deliveryStateRegionId
      deliveryPostalCode
      deliveryTelephoneNumber
      deliveryEmailAddress
      scheduledDeliveryDate
      deliveryNotes
      isDeliveryTracked
      purchaseOrderNumber
      isDraft
      statusType {
        statusType
      }
      _isApprovalDocumentsRequired
      _requiredApprovalDocuments
      purchaseOrderItems(orderBy: _SORT_ITEM_NUMBER_ASC) {
        nodes {
          id
          _rowTimestamp
          __typename
          purchaseOrderItemTypeId
          purchaseOrderItemType {
            calculationType
            layoutType
            abbreviation
            description
            id
          }
          itemNumber
          _isUpdatable
          _isDeletable
          itemExtendedAmount
          displayPoItemAccount
          displayPoItemQuantity
          displayPoItemUnitPrice
          displayPoItemTotal
          displayPoItemDescription
          displayPoItemRentalTerm
          displayPoItemType
          description
          isTaxable
          isDiscounted
          _extendedItemTotal
          itemQuantity
          itemRentalDates
          itemUnitPrice
          itemFromDate
          purchaseOrderItemType {
            layoutType
            abbreviation
          }
          _isActive
        }
      }
      _rowTimestamp
      purchaseOrderType {
        purchaseOrderType
      }
      _isEnvironmentalsExist
      _isPromoteAddressAllowed
      _isStagedApprovalRequest
      _isApprovalRevocable
      department {
        name
        id
      }
      _statusTypeId
      _isAccountingEntry
      _isHistory
      _isStampAllowed
      _isUnstampAllowed
      _isTransactionCancelled
      _isAccountingEntryStampedComplete
      _accountingStampDate
      _accountingStampUserName
      _accountingStampTransactionReference
      _isInvoiceScheduleViewable
      _isInvoiceScheduleUpdatable
      _emailDocument {
        ...EmailDocumentFields
      }
      emailDocumentsByEntityId(orderBy: _CREATED_DATE_DESC) {
        nodes {
          ...EntityEmailDocumentsFields
        }
      }
    }
  }
}
